import { all, fork } from 'redux-saga/effects'

import app from './app'
import dataCenter from './dataCenter'
import patrolCenter from './patrolCenter'

export default function* rootSaga() {
  yield all([fork(app), fork(dataCenter), fork(patrolCenter)])
}
